// 3rd
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import VueI18n from 'vue-i18n';

import { LOCAL_STORAGE_LOCALE } from '../utils/constants';

// custom themes
import dark from './vuetify/theme';

// css
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify);
Vue.use(VueI18n);

import vuetifyEn from 'vuetify/src/locale/en.ts';
import vuetifyDe from 'vuetify/src/locale/de.ts';

const messages = {
    en: {
        $vuetify: {
            ...vuetifyEn,
        },
    },
    de: {
        $vuetify: {
            ...vuetifyDe,
        },
    },
};

// default
let locale = 'de';
// locale is already saved in local storage
if (localStorage.getItem(LOCAL_STORAGE_LOCALE)) {
    locale = localStorage.getItem(LOCAL_STORAGE_LOCALE);
} else {
    // get browser locale
    locale = window.navigator.language.slice(0, 2) || navigator.userLanguage.slice(0, 2);
    localStorage.setItem(LOCAL_STORAGE_LOCALE, locale);
}

export const i18n = new VueI18n({
    locale: locale,
    messages,
    silentTranslationWarn: true
});

export default new Vuetify({
    icons: {
        iconfont: 'mdi',
    },
    theme: {
        dark: true,
        themes: {
            dark
        },
    },
    lang: {
        t: (key, ...params) => i18n.t(key, params),
    },
});
